import { createSlice } from '@reduxjs/toolkit'
import constants from '../../constants'

const initialState = {
  step: constants.booking.pageNumber.vehicles,
  selectedVehicle: null,
  alternateVehicle: null,
  selectedExtras: [],
  filters: {},
  sort: 'default',
  milesNBonusAccount: null,
  mbData: {
    redeemEnabled: false,
    redeemAmount: 0,
    hasRemainingCost: true,
  },
  fleetVehicle: null,
  type: 'modify',
  modifiedValues: {},
  modifiedPrices: {
    // initialPaymentWithCard: 0,
    // initialPaymentWithMiles: 0,
    // newAmountPaidWithMiles: 0,
    // restToBePaidWithCard: 0,
    // refund: 0,
  },
  isPrepaid: true,
  showAddressFields: false,
  needsChanges: false,
  showMilesNBonus: false,
  hasFlightNumber: false,
  upsellUpgraded: false,
  cancelationFee: 0,
  paymentNotice: '',
  specialRequests: '',
  inpathCars: [],
  latestSearch: null,
}

export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    reset: (state) => {
      Object.assign(state, initialState)
    },

    // Reset data for steps 2 and 3 when on step 1
    resetSteps2And3: (state) => {
      if (state.type === 'modify') {
        state.mbData = {
          redeemEnabled: false,
          redeemAmount: 0,
          hasRemainingCost: true,
        }
        return
      }
      // Reset vehicle selection (step 2)
      state.selectedVehicle = null
      state.alternateVehicle = null
      state.upsellUpgraded = false
      // state.fleetVehicle = {}

      // Reset extras (step 2)
      state.selectedExtras = []

      // Reset payment related data (step 3)
      state.mbData = {
        redeemEnabled: false,
        redeemAmount: 0,
        hasRemainingCost: true,
      }
      state.showAddressFields = false
      state.hasFlightNumber = false
    },
    // Reset data for step 3 when on step 2
    resetStep3: (state) => {
      if (state.type === 'modify') {
        state.mbData = {
          redeemEnabled: false,
          redeemAmount: 0,
          hasRemainingCost: true,
        }
        return
      }
      // Reset payment related data (step 3)
      state.mbData = {
        redeemEnabled: false,
        redeemAmount: 0,
        hasRemainingCost: true,
      }
      state.showAddressFields = false
      state.hasFlightNumber = false
    },
    setStep: (state, action) => {
      state.step = action.payload
    },
    setSelectedVehicle: (state, action) => {
      state.selectedVehicle = action.payload
    },
    setAlternateVehicle: (state, action) => {
      state.alternateVehicle = action.payload
    },
    setSelectedExtras: (state, action) => {
      state.selectedExtras = action.payload
    },
    setFilters: (state, action) => {
      state.filters = action.payload
    },
    setSort: (state, action) => {
      state.sort = action.payload
    },
    setMilesNBonusAccount: (state, action) => {
      state.milesNBonusAccount = action.payload
    },
    resetMilesNBonusAccount: (state) => {
      state.milesNBonusAccount = {}
    },
    setMbData: (state, action) => {
      state.mbData[action.payload.key] = action.payload.value
    },
    resetMBData: (state) => {
      state.mbData = {
        redeemEnabled: false,
        redeemAmount: 0,
        hasRemainingCost: true,
      }
    },
    setFleetVehicle: (state, action) => {
      state.fleetVehicle = action.payload
    },
    setIsPrepaid: (state, action) => {
      state.isPrepaid = action.payload
    },
    setHasFlightNumber: (state, action) => {
      state.hasFlightNumber = action.payload
    },
    setType: (state, action) => {
      state.type = action.payload
    },
    setModifiedValues: (state, action) => {
      state.modifiedValues = action.payload
    },
    setModifiedPrices: (state, action) => {
      state.modifiedPrices = action.payload
    },
    setShowAddressFields: (state, action) => {
      state.showAddressFields = action.payload
    },
    setNeedsChanges: (state, action) => {
      state.needsChanges = action.payload
    },
    setShowMilesNBouns: (state, action) => {
      state.showMilesNBonus = action.payload
    },
    setCancelationFee: (state, action) => {
      state.cancelationFee = action.payload
    },
    setPaymentNotice: (state, action) => {
      state.paymentNotice = action.payload
    },
    setUpsellUpgraded: (state, action) => {
      state.upsellUpgraded = action.payload
    },
    setSpecialRequests: (state, action) => {
      state.specialRequests = action.payload
    },
    setInpathCars: (state, action) => {
      state.inpathCars = action.payload || []
    },
    setLatestSearch: (state, action) => {
      state.latestSearch = action.payload || null
    },
  },
})
export const {
  resetSteps2And3,
  resetStep3,
  setStep,
  setSelectedVehicle,
  setAlternateVehicle,
  setPricing,
  setSelectedExtras,
  setFilters,
  setSort,
  setMilesNBonusAccount,
  resetMilesNBonusAccount,
  setMbData,
  resetMBData,
  setFleetVehicle,
  setIsPrepaid,
  setHasFlightNumber,
  setType,
  setModifiedValues,
  setModifiedPrices,
  setShowAddressFields,
  setNeedsChanges,
  setShowMilesNBouns,
  setCancelationFee,
  setPaymentNotice,
  setUpsellUpgraded,
  setSpecialRequests,
  setInpathCars,
  setLatestSearch,
} = bookingSlice.actions
export default bookingSlice.reducer
